import { useTranslation } from "react-i18next";
import { Button, EmptyState } from "@tellescope/design-system";
import { Sparkles } from "lucide-react";
import { AISummaryGenerating } from "./AISummaryGenerating";

export interface AISummaryEmptyProps {
  onGenerate: () => void;
  isGenerating: boolean;
  disabled?: boolean;
}

export const AISummaryEmpty = ({ onGenerate, isGenerating, disabled = false }: AISummaryEmptyProps) => {
  const { t } = useTranslation("contacts");

  return (
    <EmptyState size="compact" className="w-full">
      {isGenerating ? (
        <AISummaryGenerating />
      ) : (
        <>
          <EmptyState.Media>
            <Sparkles className="h-5 w-5 text-muted-foreground" />
          </EmptyState.Media>
          <EmptyState.Subtitle>{t("No AI summary yet")}</EmptyState.Subtitle>
          <EmptyState.Actions>
            <Button variant="outline" size="sm" onClick={onGenerate} disabled={disabled}>
              {t("Generate summary")}
            </Button>
          </EmptyState.Actions>
        </>
      )}
    </EmptyState>
  );
};
